// extracted by mini-css-extract-plugin
export default {"page":"N0-z","cartModal":"O0-z","checkout":"P0-z","placeholder":"Q0-z","account":"R0-z"};